function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExisting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M546.71,407.77a18.28,18.28,0,0,1,0,29.45L370.82,566.45a18.27,18.27,0,0,1-21.64,0L173.3,437.22a18.28,18.28,0,0,1,0-29.45",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.29,345.29a18.27,18.27,0,0,0,0,29.45l17.26,12.7L349.18,504a18.27,18.27,0,0,0,21.64,0L529.45,387.44l17.26-12.7a18.27,18.27,0,0,0,0-29.45",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.7,282.77,370.82,153.55a18.27,18.27,0,0,0-21.64,0L173.3,282.77a18.28,18.28,0,0,0,0,29.46l17.26,12.69,37.29,27.42,121.34,89.12a18.27,18.27,0,0,0,21.64,0l121.34-89.12,37.29-27.42,17.26-12.69A18.28,18.28,0,0,0,546.7,282.77Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 720,
    style: {
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExisting);
export default __webpack_public_path__ + "static/media/existing.66cfe5792d977c40111b0783039dd385.svg";
export { ForwardRef as ReactComponent };